import React from "react";

import {
  AccountCircleRounded,
  AdminPanelSettingsRounded,
  BiotechRounded,
  BusAlertRounded,
  CloudUploadRounded,
  DepartureBoardRounded,
  DnsRounded,
  HelpRounded,
  HomeRounded,
  LoginRounded,
  LogoutRounded,
  NotificationsRounded,
  QuestionAnswerRounded,
  SettingsRemoteRounded,
  SettingsRounded,
  StorefrontRounded,
  SupervisedUserCircleRounded,
  SystemSecurityUpdateWarningRounded,
  TextSnippetRounded,
  ViewTimelineRounded,
} from "@mui/icons-material";
import { ButtonBase } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useLocation, useNavigate } from "react-router-dom";

import useAuth from "../../config/context/authContext";
import useFirebase from "../../config/context/firebaseContext";
import useMainState from "../../config/context/mainStateContext";
import { GreyPallet } from "../../config/styles";
import { UtilComponents } from "../../config/util/utilComponents";

import MainText from "../MainText";

export default function SideMenuDrawer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { getConfig } = useFirebase();

  const { currentUserInfo, currentUserState, authLogOutUser, loadingLocalUserData } = useAuth();
  const { showSideMenuDrawer, setShowSideMenuDrawer } = useMainState();

  return (
    <React.Fragment>
      <Drawer
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "0px !important",
          },
          "& .MuiButtonBase-root": {
            borderRadius: "15px !important",
            fontWeight: "bold",
            minHeight: 60,
            mb: 1,

            "& .MuiTypography-root": {
              fontWeight: "bold",
            },
          },
        }}
        keepMounted={true}
        anchor={"left"}
        open={showSideMenuDrawer}
        onClose={() => setShowSideMenuDrawer(false)}
      >
        <Box
          sx={{ width: 250, p: 1 }}
          role="presentation"
          onClick={() => setShowSideMenuDrawer(false)}
          onKeyDown={() => setShowSideMenuDrawer(false)}
        >
          <ButtonBase sx={{ width: "100%" }} onClick={() => navigate("/account")}>
            <Box
              sx={{ p: 2 }}
              style={{
                backgroundColor: GreyPallet.Light,
                borderRadius: 15,
                minHeight: 70,
                width: "100%",
              }}
              display={"flex"}
              justifyContent={"start"}
              alignItems={"center"}
            >
              {currentUserState ? (
                <AccountCircleRounded
                  sx={{
                    mr: 1,
                    fontSize: "36px",
                    color: currentUserInfo?.color || GreyPallet.Black,
                  }}
                />
              ) : null}

              {currentUserState ? (
                <MainText color="black" size="subtitle">
                  {currentUserInfo?.name || "Sem Nome"}
                </MainText>
              ) : loadingLocalUserData ? (
                <MainText color="regular" size="subtitle">
                  Carregando...
                </MainText>
              ) : (
                <MainText color="regular" size="subtitle">
                  Circular UFRN
                </MainText>
              )}
            </Box>
          </ButtonBase>

          <List>
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  backgroundColor: location.pathname.includes("/home")
                    ? GreyPallet.LightGhost
                    : undefined,
                }}
                onClick={() => navigate("/home/bus")}
              >
                <ListItemIcon>
                  <HomeRounded />
                </ListItemIcon>
                <ListItemText primary={"Início"} />
              </ListItemButton>
            </ListItem>

            {getConfig("enabled_spott") === true && (
              <ListItem disablePadding>
                <ListItemButton
                  sx={{
                    backgroundColor:
                      location.pathname === "/help" ? GreyPallet.LightGhost : undefined,
                  }}
                  onClick={() => navigate("/help")}
                >
                  <ListItemIcon>
                    <HelpRounded />
                  </ListItemIcon>
                  <ListItemText primary={"Ajuda"} />
                </ListItemButton>
              </ListItem>
            )}

            {currentUserState ? (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/account" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/account")}
                  >
                    <ListItemIcon>
                      <AccountCircleRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Perfil"} />
                  </ListItemButton>
                </ListItem>

                {getConfig("enabled_spott") === true && (
                  <ListItem disablePadding>
                    <ListItemButton
                      sx={{
                        backgroundColor:
                          location.pathname === "/account/posts"
                            ? GreyPallet.LightGhost
                            : undefined,
                      }}
                      onClick={() => navigate("/account/posts")}
                    >
                      <ListItemIcon>
                        <TextSnippetRounded />
                      </ListItemIcon>
                      <ListItemText primary={"Postagens"} />
                    </ListItemButton>
                  </ListItem>
                )}

                {getConfig("enabled_chat") || UtilComponents.isStaff(currentUserState) ? (
                  <ListItem disablePadding>
                    <ListItemButton
                      sx={{
                        backgroundColor:
                          location.pathname === "/account/chats"
                            ? GreyPallet.LightGhost
                            : undefined,
                      }}
                      onClick={() => navigate("/account/chats")}
                    >
                      <ListItemIcon>
                        <QuestionAnswerRounded />
                      </ListItemIcon>
                      <ListItemText primary={"Chats"} />
                    </ListItemButton>
                  </ListItem>
                ) : null}

                {getConfig("enabled_cafeteria") || UtilComponents.isStaff(currentUserState) ? (
                  <ListItem disablePadding>
                    <ListItemButton
                      sx={{
                        backgroundColor: location.pathname.includes("/cafeteria")
                          ? GreyPallet.LightGhost
                          : undefined,
                      }}
                      onClick={() => navigate("/cafeteria")}
                    >
                      <ListItemIcon>
                        <StorefrontRounded />
                      </ListItemIcon>
                      <ListItemText primary={"Lanchonete"} />
                    </ListItemButton>
                  </ListItem>
                ) : null}
              </>
            ) : null}

            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  "&.MuiButtonBase-root": { mb: 0 },
                  backgroundColor:
                    location.pathname === "/settings" ? GreyPallet.LightGhost : undefined,
                }}
                onClick={() => navigate("/settings")}
              >
                <ListItemIcon>
                  <SettingsRounded />
                </ListItemIcon>
                <ListItemText primary={"Configurações"} />
              </ListItemButton>
            </ListItem>
          </List>

          {/* Admin */}

          {UtilComponents.isStaff(currentUserState) && (
            <>
              <Divider />

              <List>
                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/dashboard"
                          ? GreyPallet.LightGhost
                          : undefined,
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    <ListItemIcon>
                      <AdminPanelSettingsRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Dashboard"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/user" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/admin/user")}
                  >
                    <ListItemIcon>
                      <SupervisedUserCircleRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Usuários"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/banner" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/admin/banner")}
                  >
                    <ListItemIcon>
                      <ViewTimelineRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Banners"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/notification"
                          ? GreyPallet.LightGhost
                          : undefined,
                    }}
                    onClick={() => navigate("/admin/notification")}
                  >
                    <ListItemIcon>
                      <NotificationsRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Notificações"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/bus/schedules"
                          ? GreyPallet.LightGhost
                          : undefined,
                    }}
                    onClick={() => navigate("/admin/bus/schedules")}
                  >
                    <ListItemIcon>
                      <DepartureBoardRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Itinerários"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/bus/rules"
                          ? GreyPallet.LightGhost
                          : undefined,
                    }}
                    onClick={() => navigate("/admin/bus/rules")}
                  >
                    <ListItemIcon>
                      <BusAlertRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Regras"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/file" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/admin/file")}
                  >
                    <ListItemIcon>
                      <CloudUploadRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Arquivos"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/request" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/admin/request")}
                  >
                    <ListItemIcon>
                      <DnsRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Requisições"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/errors" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/admin/errors")}
                  >
                    <ListItemIcon>
                      <SystemSecurityUpdateWarningRounded />
                    </ListItemIcon>
                    <ListItemText primary={"Erros"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      backgroundColor:
                        location.pathname === "/admin/remote" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/admin/remote")}
                  >
                    <ListItemIcon>
                      <SettingsRemoteRounded />
                    </ListItemIcon>
                    <ListItemText sx={{ textOverflow: "ellipsis" }} primary={"Conf. Remotas"} />
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    sx={{
                      "&.MuiButtonBase-root": { mb: 0 },
                      backgroundColor:
                        location.pathname === "/admin/test" ? GreyPallet.LightGhost : undefined,
                    }}
                    onClick={() => navigate("/admin/test")}
                  >
                    <ListItemIcon>
                      <BiotechRounded />
                    </ListItemIcon>
                    <ListItemText sx={{ textOverflow: "ellipsis" }} primary={"Testes"} />
                  </ListItemButton>
                </ListItem>
              </List>
            </>
          )}

          <Divider />

          {/* Logout */}

          <List>
            {currentUserState ? (
              <ListItem disablePadding>
                <ListItemButton onClick={authLogOutUser}>
                  <ListItemIcon>
                    <LogoutRounded />
                  </ListItemIcon>
                  <ListItemText primary={"Sair"} />
                </ListItemButton>
              </ListItem>
            ) : (
              <ListItem disablePadding>
                <ListItemButton
                  sx={{
                    "&.MuiButtonBase-root": { mb: 0 },
                    backgroundColor:
                      location.pathname === "/account" ? GreyPallet.LightGhost : undefined,
                  }}
                  onClick={() => navigate("/account")}
                >
                  <ListItemIcon>
                    <LoginRounded />
                  </ListItemIcon>
                  <ListItemText primary={"Login"} />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Box>
      </Drawer>
    </React.Fragment>
  );
}
